import './App.css';
import { Route, Routes } from 'react-router-dom';
import React, { useEffect } from 'react';
import Home from './Pages/User/Home';
import Parking from './Pages/User/Timeline';
import AdminParking from './Pages/Admin/Timeline';
import AdminHistory from './Pages/Admin/History';
import AdminUsers from './Pages/Admin/Users';
import GuestParking from './Pages/Guest/Timeline';
import Login from './Pages/Authentication/Login/Login';
import ForgotPassword from './Pages/Authentication/Forgot/Forgot';
import Landing from './Pages/Authentication/Landing/Landing';
function App() {
  useEffect(() => {
    const userAgent = navigator.userAgent;
    const rootElement = document.getElementById('root');

    if (userAgent.includes('Firefox')) {
      rootElement?.classList.add('firefox');
    } else if (userAgent.includes('Edg')) {  // Microsoft Edge detection
      rootElement?.classList.add('edge');
    } else if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {  
      rootElement?.classList.add('chrome');
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      rootElement?.classList.add('safari');
    }
  }, []);
  return (
    <React.Fragment>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path='/home' element={<Home />} />
        <Route path='/login' element={<Login />} />
        <Route path='/forgot' element={<ForgotPassword />} />
        <Route path='/timetable' element={<Parking />} />
        <Route path='/guests' element={<GuestParking />} />
        <Route path='/admin/timetable' element={<AdminParking />} />
        <Route path='/admin/history' element={<AdminHistory />} />
        <Route path='/admin/users' element={<AdminUsers />} />
      </Routes>
    </React.Fragment>
 
  );
}

export default App;
